import { render, staticRenderFns } from "./OfferBasket.vue?vue&type=template&id=f3adc8fe&scoped=true"
import script from "./OfferBasket.vue?vue&type=script&lang=js"
export * from "./OfferBasket.vue?vue&type=script&lang=js"
import style0 from "./OfferBasket.vue?vue&type=style&index=0&id=f3adc8fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3adc8fe",
  null
  
)

export default component.exports